module.exports = __webpack_public_path__ + "static/img/z12.7e969d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z12.png
// module id = tOOp
// module chunks = 0